/**
 * Devuelve el html para pintar los errores en forma de arbol
 *
 * @param {Object} errors La lista de errores
 * @param {Object} LOCALE Traducciones de los mensajes de error
 * @returns {string}
 */
export function render(errors, LOCALE) {
  return Object.keys(errors).reduce((html, name) => {
    // saltamos "CAB"
    const sections = orderBySection(errors[name].properties);
    setCounters(sections);
    return html + renderSections(sections);
  }, '');

  function orderBySection(propertiesFromCAB, sections = {}) {
    return Object.keys(propertiesFromCAB).reduce((acc, cur) => {
      const property = propertiesFromCAB[cur];
      if (!property.section) {
        // property que no tiene "section"
        // puede ser tipicamente un tipo objeto que no se representa en el view,
        // pero tratamos sus hijos
        if (!property.properties && !Object.keys(property.properties).length) {
          return acc;
        } // ERROR no tiene hijos. Lo saltamos
        return orderBySection(property.properties, sections);
      }
      acc[property.section.name] = acc[property.section.name] || {
        properties: {},
      };
      acc[property.section.name].properties[cur] = property;
      acc[property.section.name].title = property.section.title;
      return acc;
    }, sections);
  }

  function setCounters(sections) {
    Object.values(sections).forEach(section => (section.counter = count(section)));

    function count(section) {
      return Object.values(section.properties).reduce((acc, cur) => acc + (cur.errors || []).length + (cur.properties ? count(cur) : 0), 0);
    }
  }

  function renderSections(sections) {
    const list = Object.keys(sections).reduce((acc, cur) => {
      const section = sections[cur],
        content = renderSection(section);
      return !content
        ? acc
        : `${acc}
          <li>
            <strong>${section.title}</strong>&nbsp;<ec-badge ec-danger>${section.counter}</ec-badge>
            <ul>${content}</ul>
          </li>`;
    }, '');
    return list ? `<ul ec-tree="bubble">${list}</ul>` : '';
    //@odeniel no podemos sin compilar: <ec-collapse label="${section.title}">${content}</ec-collapse>
  }

  function renderSection(section) {
    return Object.keys(section.properties).reduce((acc, cur) => `${acc}${handleProperty(section.properties[cur])}`, '');
  }

  function renderProperties(properties, indexes) {
    return (
      Object.keys(properties)
        .map(child => handleProperty(properties[child], child, Object.assign([], indexes)))
        .join('') || ''
    );
  }

  function handleProperty(property, name = '', indexes = []) {
    if (typeof property.index === 'number') {
      indexes.push(property.index);
    }

    const indexesList = indexes.toString(),
      isErrors = property.errors && !!property.errors.length,
      childsTemplate = renderProperties(property.properties, indexes);
    //
    if (!isErrors && !childsTemplate) {
      return '';
    }

    if (!property.title) {
      // @odeniel - para EXTRADATA porque el "CAB.LIN.EXTRADATA[0]" no tiene title,
      // solo tiene el parentRequired y el model.
      // Necesitamos conservarlo para validar jerarquicamente sus hijos: CAB.LIN.EXTRADATA[0].VALUE
      // Ademas, lo de saltar este padre, hace que el campo se pinta a nivel de linea,
      // lo cual es mas correcto para el usuario ya que el campo esta a nivel de grid ("LIN.EXTRADATA[0].VALUE" es equivalente a LIN.EAN por ejemplo)

      if (isErrors) {
        console.warn(`fbErrors.render: el campo "${property.model}" tiene errores pero le falta su titulo, no se puede pintar al usuario. Revisa los in4/view.`);
      }
      return childsTemplate;
    }
    // ${property.level ? '[embalaje level'+property.level+' = tipo camion o palet o caja] ' : ''}
    return `
        <li>
          <div
            data-section="${(property.section && property.section.name) || ''}"
            data-model="${property.model || ''}"
            data-indexes="${indexesList}"
            ec-hover>
              ${property.title || name}
              ${!isErrors ? '' : `${property.errors.map(error => `<ec-badge ec-alt>${LOCALE[error]}</ec-badge>`).join(' ')}`}
          </div>
          <ul>${childsTemplate}</ul>
        </li>
      `;
  }
}
